/**
 * F.U.C.K. T.H.A.T.T. Flash Cards by Cabrini Schnyder.
 * 50 tarot-style inspiration cards.
 *   front — the headline card (acronym + witty line + Tree of Life)
 *   back  — the "Cabrini Check-In" (full quote, Question, Declaration)
 * Images live in /public/cards (web-optimized .webp).
 */
const pad = (n) => String(n).padStart(2, '0');

export const FLASHCARDS = Array.from({ length: 50 }, (_, i) => {
  const n = pad(i + 1);
  return {
    id: i + 1,
    front: `/cards/card_${n}_front.webp`,
    back: `/cards/card_${n}_back.webp`,
    alt: `F.U.C.K. T.H.A.T.T. Flash Card ${i + 1} by Cabrini Schnyder`,
  };
});

export const FLASHCARD_COUNT = FLASHCARDS.length;
